import {useNavigate, useParams} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";

import {getInspection} from "../../../api/maintenance/InspectionService";

import React, {useEffect, useState} from "react";

import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";

import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";

import {InspectionInfo} from "./subPages/InspectionInfo";

import {ContentCategory} from "../../../constant/CodeSpecNum";

import {skeleton} from "../../../redux/slice/apiSlice";

import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";

import {getContentStatus} from "../../../api/contentStatus/contentStatusService";

import {InspectionReport} from "./report/InspectionReport";



const DEFAULT_TABS = [

    {clicked: true, name: "기본정보"},

    {clicked: false, name: "점검보고서"},

    {clicked: false, name: "이력관리"},

];



function InspectionTab(){

    const { id } = useParams();

    const dispatch = useDispatch();

    const refreshContent = useSelector(state => state.status.refreshContent);

    const statusNumericValue = useSelector(state => state.content.statusNumericValue);



    const [inspection, setInspection] = useState({});

    const [tabs, setTabs] = useState(DEFAULT_TABS);

    const navigate = useNavigate();



    useEffect(() => {

        setInspection({});

        setTabs(DEFAULT_TABS);

        dispatch(changeStatusNumericValue(0));

        dispatch(changeProgressStatusValue({}));

    }, [id, dispatch]);



    useEffect(() =>{

        let cancelled = false;



        Promise.all([

            getInspection(id),

            getContentStatus({contentId : id, contentCategory : ContentCategory.INSPECTION})

        ]).then(([inspectionResponse, statusNumericValueResponse]) => {

            if (cancelled) return;



            if(inspectionResponse.status === 201) {

                if (inspectionResponse.data.errorCode = 'AUTHORITY') {

                    alert(inspectionResponse.data.reason)

                    navigate(-1)

                }

            }



            setInspection({

                ...inspectionResponse.data,

                assetSingleOrBulkUse : "bulk",

                periodDateLimit : 1,

                required_validate : {

                    periodDateLimit : true

                }

            });



            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {

                const numericValue = statusNumericValueResponse.data.statusNumericValue;

                dispatch(changeStatusNumericValue(numericValue));

                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));

            }



        }).finally(() => {

            if (!cancelled) {

                dispatch(skeleton(false));

            }

        });



        return () => {

            cancelled = true;

        };

    }, [id, dispatch, refreshContent, navigate]);



    if(Object.keys(inspection).length > 0) {

        return (

            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />

                    {tabs[0].clicked && <InspectionInfo inspection={inspection} statusNumericValue={statusNumericValue} />}

                    {tabs[1].clicked && <InspectionReport id={id} inspection={inspection} statusNumericValue={statusNumericValue} />}

                    {tabs[2].clicked && <CommonHistoryList id={id} tableName={"점검관리"} />}
                </DetailHeroSummaryProvider>
            </div>

        );

    }

}



export {InspectionTab}
